import { useState, useEffect, useCallback } from "react";

import { API } from "../config";

// ── Stili comuni (coerenti con MonitorLive.js / DiarioCapitale.js) ──
const FONT = "'DM Sans', sans-serif";
const MONO = "'IBM Plex Mono', monospace";

const stili = {
  card: {
    background: "#fff", borderRadius: 10,
    border: "1px solid #E2E8F0",
    padding: "16px 20px", marginBottom: 16,
  },
  intestazioneCard: {
    display: "flex", justifyContent: "space-between",
    alignItems: "center", marginBottom: 14,
  },
  titoloCard: {
    fontSize: 15, fontWeight: 700, color: "#1E293B", margin: 0,
  },
  sottotitolo: {
    fontSize: 12, color: "#64748B", marginTop: 2,
  },
  btn: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "7px 16px", borderRadius: 6, border: "none",
    cursor: "pointer", transition: "background 0.15s",
  },
  btnPrimary: {
    background: "#2563EB", color: "#fff",
  },
  btnSecondary: {
    background: "#F1F5F9", color: "#475569",
    border: "1px solid #CBD5E1",
  },
  btnIcona: {
    fontFamily: FONT, fontSize: 13,
    padding: "4px 8px", borderRadius: 4, border: "none",
    cursor: "pointer", background: "transparent",
  },
  // ── Tabella ─────────────────────────────────────────────────
  tabella: {
    width: "100%", borderCollapse: "collapse", fontFamily: FONT,
  },
  th: {
    fontSize: 11, fontWeight: 700, color: "#64748B",
    padding: "8px 10px", textAlign: "left",
    borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap",
    background: "#F8FAFC",
  },
  thNum: {
    fontSize: 11, fontWeight: 700, color: "#64748B",
    padding: "8px 10px", textAlign: "right",
    borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap",
    background: "#F8FAFC",
  },
  thCenter: {
    fontSize: 11, fontWeight: 700, color: "#64748B",
    padding: "8px 10px", textAlign: "center",
    borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap",
    background: "#F8FAFC",
  },
  td: {
    fontSize: 13, padding: "9px 10px", color: "#334155",
    borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap",
    fontFamily: FONT,
  },
  tdNum: {
    fontSize: 13, padding: "9px 10px", color: "#334155",
    borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap",
    fontFamily: MONO, textAlign: "right",
  },
  tdCenter: {
    fontSize: 13, padding: "9px 10px", color: "#334155",
    borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap",
    textAlign: "center",
  },
  saldoCellLink: {
    fontFamily: MONO, fontWeight: 700, cursor: "pointer",
    color: "#1E293B", textDecoration: "underline",
    textDecorationStyle: "dotted", textUnderlineOffset: 3,
  },
  badgeStato: {
    display: "inline-block", padding: "2px 10px",
    borderRadius: 12, fontSize: 11, fontWeight: 600,
  },
  badgeDefault: {
    display: "inline-block", padding: "2px 8px",
    borderRadius: 12, fontSize: 10, fontWeight: 700,
    background: "#DBEAFE", color: "#1E40AF",
    marginLeft: 6,
  },
  badgeTipo: {
    display: "inline-block", padding: "2px 10px",
    borderRadius: 12, fontSize: 11, fontWeight: 600,
  },
  // ── Filtro ──────────────────────────────────────────────────
  filtroRiga: {
    display: "flex", gap: 12, alignItems: "center",
    marginBottom: 12,
  },
  filtroLabel: {
    fontSize: 12, fontWeight: 600, color: "#475569",
  },
  // ── Modal ───────────────────────────────────────────────────
  modalOverlay: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(15, 23, 42, 0.5)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    background: "#fff", borderRadius: 12,
    padding: "24px 28px", width: 460, maxWidth: "90vw",
    maxHeight: "90vh", overflowY: "auto",
    fontFamily: FONT,
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
  },
  modalTitolo: {
    fontSize: 18, fontWeight: 700, color: "#1E293B",
    margin: "0 0 6px 0",
  },
  modalSottotitolo: {
    fontSize: 12, color: "#64748B", marginBottom: 18,
  },
  campoRiga: {
    marginBottom: 14,
  },
  label: {
    fontSize: 12, fontWeight: 600, color: "#475569",
    marginBottom: 4, display: "block",
  },
  input: {
    fontFamily: FONT, fontSize: 13, padding: "8px 10px",
    borderRadius: 6, border: "1px solid #CBD5E1",
    background: "#fff", color: "#1E293B", width: "100%",
    boxSizing: "border-box", outline: "none",
  },
  textarea: {
    fontFamily: FONT, fontSize: 13, padding: "8px 10px",
    borderRadius: 6, border: "1px solid #CBD5E1",
    background: "#fff", color: "#1E293B", width: "100%",
    boxSizing: "border-box", outline: "none",
    resize: "vertical", minHeight: 60,
  },
  select: {
    fontFamily: FONT, fontSize: 13, padding: "8px 10px",
    borderRadius: 6, border: "1px solid #CBD5E1",
    background: "#fff", color: "#1E293B", width: "100%",
    boxSizing: "border-box", outline: "none",
  },
  selectInline: {
    fontFamily: FONT, fontSize: 13, padding: "6px 10px",
    borderRadius: 6, border: "1px solid #CBD5E1",
    background: "#fff", color: "#1E293B", minWidth: 180,
    outline: "none",
  },
  checkboxRiga: {
    display: "flex", alignItems: "center", gap: 8,
  },
  radioGroup: {
    display: "flex", gap: 16, alignItems: "center",
  },
  radioLabel: {
    display: "flex", alignItems: "center", gap: 6,
    fontSize: 13, color: "#1E293B", cursor: "pointer",
  },
  modalAzioni: {
    display: "flex", justifyContent: "flex-end",
    gap: 10, marginTop: 20,
  },
  errore: {
    background: "#FFEBEE", color: "#C62828",
    padding: "10px 12px", borderRadius: 6,
    fontSize: 12, marginBottom: 14,
  },
  vuoto: {
    textAlign: "center", color: "#94A3B8",
    padding: "30px 16px", fontSize: 13,
  },
  // ── Popup breakdown saldo ───────────────────────────────────
  breakdownPopup: {
    background: "#fff", borderRadius: 10,
    padding: "20px 24px", width: 400, maxWidth: "90vw",
    fontFamily: FONT, fontSize: 13, color: "#334155",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
  },
  breakdownTitolo: {
    fontSize: 15, fontWeight: 700, color: "#1E293B",
    marginBottom: 14, paddingBottom: 10,
    borderBottom: "1px solid #E2E8F0",
  },
  breakdownRiga: {
    display: "flex", justifyContent: "space-between",
    padding: "6px 0", fontFamily: MONO,
  },
  breakdownLabel: {
    fontFamily: FONT, color: "#64748B",
  },
  breakdownTotale: {
    display: "flex", justifyContent: "space-between",
    padding: "10px 0 4px 0", marginTop: 8,
    borderTop: "2px solid #E2E8F0",
    fontFamily: MONO, fontWeight: 700, fontSize: 14,
    color: "#1E293B",
  },
  breakdownTotaleLabel: {
    fontFamily: FONT, fontWeight: 700, color: "#1E293B",
  },
};

const COLORI_STATO = {
  "attivo":   { bg: "#DCFCE7", color: "#166534" },
  "inattivo": { bg: "#F1F5F9", color: "#64748B" },
};

const COLORI_TIPO = {
  "deposito":      { bg: "#DCFCE7", color: "#166534" },
  "prelievo":      { bg: "#FEE2E2", color: "#991B1B" },
  "aggiustamento": { bg: "#FEF3C7", color: "#92400E" },
};

// v125: helper che separa migliaia con "." e decimali con "," senza usare
// toLocaleString (bug noto V8 sui numeri 1000-9999, già risolto in v124).
function _formatNumeroIT(n, dec = 2) {
  const negativo = n < 0;
  const abs = Math.abs(n);
  const intero = Math.trunc(abs);
  const decAttesi = Math.pow(10, dec);
  const decRound = Math.round((abs - intero) * decAttesi);
  const decStr = String(decRound).padStart(dec, "0");
  const interoStr = String(intero).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return (negativo ? "-" : "") + interoStr + (dec > 0 ? "," + decStr : "");
}

function formatEur(v) {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (!isFinite(n)) return "—";
  return _formatNumeroIT(n, 2) + " €";
}

function formatEurConSegno(v) {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (!isFinite(n)) return "—";
  const segno = n > 0 ? "+" : "";
  return segno + _formatNumeroIT(n, 2) + " €";
}

function formatData(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("it-IT");
  } catch { return s; }
}

function dataOggiISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

// ════════════════════════════════════════════════════════════════
// MODAL — Nuovo / Modifica bookmaker
// ════════════════════════════════════════════════════════════════
function ModalBookmaker({ bookmakerEsistente, onChiudi, onSalva }) {
  const inModifica = !!bookmakerEsistente;
  const [nome, setNome] = useState(bookmakerEsistente?.nome || "");
  const [stato, setStato] = useState(bookmakerEsistente?.stato || "attivo");
  const [feePct, setFeePct] = useState(
    bookmakerEsistente?.fee_pct_default !== undefined && bookmakerEsistente?.fee_pct_default !== null
      ? String(bookmakerEsistente.fee_pct_default)
      : ""
  );
  const [saldoIniziale, setSaldoIniziale] = useState(
    bookmakerEsistente?.saldo_iniziale_eur !== undefined && bookmakerEsistente?.saldo_iniziale_eur !== null
      ? String(bookmakerEsistente.saldo_iniziale_eur)
      : "0"
  );
  const [isDefault, setIsDefault] = useState(!!bookmakerEsistente?.is_default);
  const [salvando, setSalvando] = useState(false);
  const [errore, setErrore] = useState(null);

  const submit = async () => {
    setErrore(null);
    if (!nome.trim()) { setErrore("Inserisci il nome del bookmaker"); return; }
    const fee = feePct === "" ? 0 : parseFloat(feePct);
    if (isNaN(fee) || fee < 0) { setErrore("Fee non valida"); return; }
    const saldo = saldoIniziale === "" ? 0 : parseFloat(saldoIniziale);
    if (isNaN(saldo) || saldo < 0) { setErrore("Saldo iniziale non valido (deve essere zero o positivo)"); return; }

    setSalvando(true);
    try {
      const url = inModifica
        ? `${API}/diario/bookmaker/${bookmakerEsistente.id}`
        : `${API}/diario/bookmaker`;
      const method = inModifica ? "PUT" : "POST";
      const r = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nome: nome.trim(),
          stato,
          fee_pct_default: fee,
          is_default: isDefault,
          saldo_iniziale_eur: saldo,
        }),
      });
      const data = await r.json();
      if (!r.ok || data.detail || data.errore) {
        setErrore(data.detail || data.errore || `Errore HTTP ${r.status}`);
        setSalvando(false);
        return;
      }
      onSalva();
    } catch (e) {
      setErrore(e.message || "Errore di rete");
      setSalvando(false);
    }
  };

  return (
    <div style={stili.modalOverlay} onClick={onChiudi}>
      <div style={stili.modal} onClick={e => e.stopPropagation()}>
        <h2 style={stili.modalTitolo}>
          {inModifica ? "Modifica bookmaker" : "Nuovo bookmaker"}
        </h2>
        <div style={stili.modalSottotitolo}>
          {inModifica
            ? "Aggiorna i dati di questo bookmaker."
            : "Aggiungi un nuovo bookmaker alla tua lista."}
        </div>

        {errore && <div style={stili.errore}>{errore}</div>}

        <div style={stili.campoRiga}>
          <label style={stili.label}>Nome</label>
          <input
            type="text"
            style={stili.input}
            value={nome}
            onChange={e => setNome(e.target.value)}
            placeholder="es. Betfair, Bet365, Pinnacle..."
            autoFocus
          />
        </div>

        <div style={stili.campoRiga}>
          <label style={stili.label}>Stato</label>
          <select
            style={stili.select}
            value={stato}
            onChange={e => setStato(e.target.value)}
          >
            <option value="attivo">Attivo</option>
            <option value="inattivo">Inattivo</option>
          </select>
        </div>

        <div style={stili.campoRiga}>
          <label style={stili.label}>Fee % di default</label>
          <input
            type="number"
            step="0.01"
            min="0"
            style={stili.input}
            value={feePct}
            onChange={e => setFeePct(e.target.value)}
            placeholder="es. 5.00"
          />
        </div>

        <div style={stili.campoRiga}>
          <label style={stili.label}>Saldo iniziale (€)</label>
          <input
            type="number"
            step="0.01"
            min="0"
            style={stili.input}
            value={saldoIniziale}
            onChange={e => setSaldoIniziale(e.target.value)}
            placeholder="es. 1000.00"
          />
          <div style={{ fontSize: 11, color: "#94A3B8", marginTop: 4, fontStyle: "italic" }}>
            Somma già presente sul bookmaker al momento dell'inserimento. Lascia 0 se parti da vuoto.
          </div>
        </div>

        <div style={stili.campoRiga}>
          <label style={stili.checkboxRiga}>
            <input
              type="checkbox"
              checked={isDefault}
              onChange={e => setIsDefault(e.target.checked)}
            />
            <span style={{ fontSize: 13, color: "#475569" }}>
              Imposta come bookmaker predefinito
            </span>
          </label>
        </div>

        <div style={stili.modalAzioni}>
          <button
            style={{ ...stili.btn, ...stili.btnSecondary }}
            onClick={onChiudi}
            disabled={salvando}
          >
            Annulla
          </button>
          <button
            style={{ ...stili.btn, ...stili.btnPrimary, opacity: salvando ? 0.6 : 1 }}
            onClick={submit}
            disabled={salvando}
          >
            {salvando ? "Salvataggio..." : (inModifica ? "Salva modifiche" : "Crea bookmaker")}
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// MODAL — Nuovo / Modifica movimento
// ════════════════════════════════════════════════════════════════
function ModalMovimento({ movimentoEsistente, bookmakers, bookmakerPreselezionato, onChiudi, onSalva }) {
  const inModifica = !!movimentoEsistente;
  const [bookmakerId, setBookmakerId] = useState(
    inModifica
      ? String(movimentoEsistente.bookmaker_id)
      : (bookmakerPreselezionato?.toString() ||
         (bookmakers.find(b => b.is_default)?.id?.toString()) ||
         (bookmakers[0]?.id?.toString()) ||
         "")
  );
  const [data, setData] = useState(
    inModifica ? (movimentoEsistente.data || dataOggiISO()) : dataOggiISO()
  );
  const [tipo, setTipo] = useState(
    inModifica ? (movimentoEsistente.tipo || "deposito") : "deposito"
  );
  const [importo, setImporto] = useState(
    inModifica ? String(Number(movimentoEsistente.importo_eur || 0).toFixed(2)) : ""
  );
  const [direzione, setDirezione] = useState(
    inModifica ? (movimentoEsistente.direzione || "+") : "+"
  );
  const [note, setNote] = useState(
    inModifica ? (movimentoEsistente.note || "") : ""
  );
  const [salvando, setSalvando] = useState(false);
  const [errore, setErrore] = useState(null);

  const submit = async () => {
    setErrore(null);
    if (!bookmakerId) { setErrore("Seleziona un bookmaker"); return; }
    if (!data) { setErrore("Inserisci la data"); return; }
    const imp = parseFloat(importo);
    if (!imp || isNaN(imp) || imp <= 0) {
      setErrore("Inserisci un importo valido (maggiore di zero)");
      return;
    }

    // Calcolo direzione finale: se aggiustamento -> usa scelta utente, altrimenti backend la deriva
    const dirFinale = (tipo === "aggiustamento") ? direzione : (tipo === "deposito" ? "+" : "-");

    setSalvando(true);
    try {
      const url = inModifica
        ? `${API}/diario/bookmaker/movimenti/${movimentoEsistente.id}`
        : `${API}/diario/bookmaker/movimenti`;
      const method = inModifica ? "PUT" : "POST";
      const r = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          bookmaker_id: parseInt(bookmakerId, 10),
          data,
          tipo,
          importo_eur: imp,
          direzione: dirFinale,
          note: note.trim() || null,
        }),
      });
      const dataResp = await r.json();
      if (!r.ok || dataResp.detail || dataResp.errore) {
        setErrore(dataResp.detail || dataResp.errore || `Errore HTTP ${r.status}`);
        setSalvando(false);
        return;
      }
      onSalva();
    } catch (e) {
      setErrore(e.message || "Errore di rete");
      setSalvando(false);
    }
  };

  return (
    <div style={stili.modalOverlay} onClick={onChiudi}>
      <div style={stili.modal} onClick={e => e.stopPropagation()}>
        <h2 style={stili.modalTitolo}>
          {inModifica ? "Modifica movimento" : "Nuovo movimento"}
        </h2>
        <div style={stili.modalSottotitolo}>
          {inModifica
            ? "Aggiorna i dati di questo movimento."
            : "Registra un deposito, prelievo o aggiustamento sul bookmaker."}
        </div>

        {errore && <div style={stili.errore}>{errore}</div>}

        <div style={stili.campoRiga}>
          <label style={stili.label}>Bookmaker</label>
          <select
            style={stili.select}
            value={bookmakerId}
            onChange={e => setBookmakerId(e.target.value)}
          >
            <option value="">— Seleziona —</option>
            {bookmakers.map(b => (
              <option key={b.id} value={b.id}>
                {b.nome}
                {b.is_default ? " (predefinito)" : ""}
                {b.stato === "inattivo" ? " — inattivo" : ""}
              </option>
            ))}
          </select>
        </div>

        <div style={stili.campoRiga}>
          <label style={stili.label}>Data</label>
          <input
            type="date"
            style={stili.input}
            value={data}
            onChange={e => setData(e.target.value)}
          />
        </div>

        <div style={stili.campoRiga}>
          <label style={stili.label}>Tipo</label>
          <select
            style={stili.select}
            value={tipo}
            onChange={e => {
              const t = e.target.value;
              setTipo(t);
              // Auto-imposta direzione coerente quando cambia tipo
              if (t === "deposito") setDirezione("+");
              else if (t === "prelievo") setDirezione("-");
            }}
          >
            <option value="deposito">Deposito (somma al saldo)</option>
            <option value="prelievo">Prelievo (sottrae dal saldo)</option>
            <option value="aggiustamento">Aggiustamento</option>
          </select>
        </div>

        {tipo === "aggiustamento" && (
          <div style={stili.campoRiga}>
            <label style={stili.label}>Direzione</label>
            <div style={stili.radioGroup}>
              <label style={stili.radioLabel}>
                <input
                  type="radio"
                  name="direzione"
                  value="+"
                  checked={direzione === "+"}
                  onChange={() => setDirezione("+")}
                />
                Aggiunta al saldo (+)
              </label>
              <label style={stili.radioLabel}>
                <input
                  type="radio"
                  name="direzione"
                  value="-"
                  checked={direzione === "-"}
                  onChange={() => setDirezione("-")}
                />
                Sottrazione dal saldo (−)
              </label>
            </div>
          </div>
        )}

        <div style={stili.campoRiga}>
          <label style={stili.label}>Importo (€)</label>
          <input
            type="number"
            step="0.01"
            min="0.01"
            style={stili.input}
            value={importo}
            onChange={e => setImporto(e.target.value)}
            placeholder="es. 500.00"
          />
        </div>

        <div style={stili.campoRiga}>
          <label style={stili.label}>Note (opzionale)</label>
          <textarea
            style={stili.textarea}
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder="es. Bonifico mensile, rettifica saldo..."
          />
        </div>

        <div style={stili.modalAzioni}>
          <button
            style={{ ...stili.btn, ...stili.btnSecondary }}
            onClick={onChiudi}
            disabled={salvando}
          >
            Annulla
          </button>
          <button
            style={{ ...stili.btn, ...stili.btnPrimary, opacity: salvando ? 0.6 : 1 }}
            onClick={submit}
            disabled={salvando}
          >
            {salvando ? "Salvataggio..." : (inModifica ? "Salva modifiche" : "Salva movimento")}
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// POPUP — Breakdown saldo bookmaker
// ════════════════════════════════════════════════════════════════
function PopupBreakdownSaldo({ saldoData, onChiudi }) {
  if (!saldoData) return null;
  return (
    <div style={stili.modalOverlay} onClick={onChiudi}>
      <div style={stili.breakdownPopup} onClick={e => e.stopPropagation()}>
        <div style={stili.breakdownTitolo}>
          Saldo {saldoData.nome}
        </div>

        <div style={stili.breakdownRiga}>
          <span style={stili.breakdownLabel}>Saldo iniziale</span>
          <span>{formatEur(saldoData.saldo_iniziale)}</span>
        </div>
        <div style={stili.breakdownRiga}>
          <span style={stili.breakdownLabel}>+ Depositi</span>
          <span style={{ color: "#166534" }}>{formatEur(saldoData.totale_depositi)}</span>
        </div>
        <div style={stili.breakdownRiga}>
          <span style={stili.breakdownLabel}>− Prelievi</span>
          <span style={{ color: "#991B1B" }}>{formatEur(saldoData.totale_prelievi)}</span>
        </div>
        <div style={stili.breakdownRiga}>
          <span style={stili.breakdownLabel}>± Aggiustamenti</span>
          <span style={{
            color: Number(saldoData.totale_aggiustamenti) > 0 ? "#166534" :
                   Number(saldoData.totale_aggiustamenti) < 0 ? "#991B1B" : "#64748B"
          }}>
            {formatEurConSegno(saldoData.totale_aggiustamenti)}
          </span>
        </div>
        <div style={stili.breakdownRiga}>
          <span style={stili.breakdownLabel}>± P/L operazioni</span>
          <span style={{
            color: Number(saldoData.totale_pl_operazioni) > 0 ? "#166534" :
                   Number(saldoData.totale_pl_operazioni) < 0 ? "#991B1B" : "#64748B"
          }}>
            {formatEurConSegno(saldoData.totale_pl_operazioni)}
          </span>
        </div>

        <div style={stili.breakdownTotale}>
          <span style={stili.breakdownTotaleLabel}>= Saldo corrente</span>
          <span>{formatEur(saldoData.saldo_corrente)}</span>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 18 }}>
          <button
            style={{ ...stili.btn, ...stili.btnSecondary }}
            onClick={onChiudi}
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// COMPONENTE PRINCIPALE — tab Bookmaker
// ════════════════════════════════════════════════════════════════
export default function DiarioBookmaker() {
  const [bookmakers, setBookmakers] = useState([]);
  const [saldi, setSaldi] = useState([]);
  const [movimenti, setMovimenti] = useState([]);
  const [filtroBookmaker, setFiltroBookmaker] = useState("");
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState(null);

  const [modalBkAperto, setModalBkAperto] = useState(false);
  const [bkInModifica, setBkInModifica] = useState(null);

  const [modalMovAperto, setModalMovAperto] = useState(false);
  const [movInModifica, setMovInModifica] = useState(null);

  const [breakdownAperto, setBreakdownAperto] = useState(null);

  const ricaricaBookmakers = useCallback(async () => {
    try {
      const r = await fetch(`${API}/diario/bookmaker`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const d = await r.json();
      setBookmakers(Array.isArray(d) ? d : []);
    } catch (e) {
      setErrore(e.message || "Errore di rete (bookmakers)");
    }
  }, []);

  const ricaricaSaldi = useCallback(async () => {
    try {
      const r = await fetch(`${API}/diario/bookmaker/saldi`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const d = await r.json();
      setSaldi(Array.isArray(d) ? d : []);
    } catch (e) {
      setErrore(e.message || "Errore di rete (saldi)");
    }
  }, []);

  const ricaricaMovimenti = useCallback(async () => {
    try {
      const url = filtroBookmaker
        ? `${API}/diario/bookmaker/movimenti?bookmaker_id=${filtroBookmaker}`
        : `${API}/diario/bookmaker/movimenti`;
      const r = await fetch(url);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const d = await r.json();
      setMovimenti(Array.isArray(d) ? d : []);
    } catch (e) {
      setErrore(e.message || "Errore di rete (movimenti)");
    }
  }, [filtroBookmaker]);

  const ricaricaTutto = useCallback(async () => {
    setLoading(true);
    setErrore(null);
    await Promise.all([ricaricaBookmakers(), ricaricaSaldi(), ricaricaMovimenti()]);
    setLoading(false);
  }, [ricaricaBookmakers, ricaricaSaldi, ricaricaMovimenti]);

  useEffect(() => { ricaricaTutto(); /* eslint-disable-next-line */ }, []);
  useEffect(() => { ricaricaMovimenti(); }, [ricaricaMovimenti]);

  const onSalvaBk = async () => {
    setModalBkAperto(false);
    setBkInModifica(null);
    await Promise.all([ricaricaBookmakers(), ricaricaSaldi()]);
  };

  const onSalvaMov = async () => {
    setModalMovAperto(false);
    setMovInModifica(null);
    await Promise.all([ricaricaMovimenti(), ricaricaSaldi()]);
  };

  const eliminaBk = async (b) => {
    if (!window.confirm(`Eliminare il bookmaker "${b.nome}"? L'operazione non è reversibile.`)) return;
    try {
      const r = await fetch(`${API}/diario/bookmaker/${b.id}`, { method: "DELETE" });
      const data = await r.json();
      if (!r.ok || data.detail || data.errore) {
        alert(data.detail || data.errore || `Errore HTTP ${r.status}`);
        return;
      }
      await Promise.all([ricaricaBookmakers(), ricaricaSaldi()]);
    } catch (e) {
      alert(e.message || "Errore di rete");
    }
  };

  const eliminaMovimento = async (m) => {
    if (!window.confirm(`Eliminare questo movimento del ${formatData(m.data)}? L'operazione non è reversibile.`)) return;
    try {
      const r = await fetch(`${API}/diario/bookmaker/movimenti/${m.id}`, { method: "DELETE" });
      const data = await r.json();
      if (!r.ok || data.detail || data.errore) {
        alert(data.detail || data.errore || `Errore HTTP ${r.status}`);
        return;
      }
      await Promise.all([ricaricaMovimenti(), ricaricaSaldi()]);
    } catch (e) {
      alert(e.message || "Errore di rete");
    }
  };

  const nomeBookmaker = (id) => {
    const b = bookmakers.find(x => x.id === id);
    return b ? b.nome : `#${id}`;
  };

  const saldoPerId = (id) => saldi.find(s => s.bookmaker_id === id);

  return (
    <div>
      {/* ═══ Card 1 — Lista bookmaker ═══════════════════════════ */}
      <div style={stili.card}>
        <div style={stili.intestazioneCard}>
          <div>
            <h2 style={stili.titoloCard}>Bookmaker</h2>
            <div style={stili.sottotitolo}>
              Lista personalizzata dei tuoi bookmaker. Solo i bookmaker attivi compariranno nel form operazioni.
            </div>
          </div>
          <button
            style={{ ...stili.btn, ...stili.btnPrimary }}
            onClick={() => { setBkInModifica(null); setModalBkAperto(true); }}
          >
            + Nuovo bookmaker
          </button>
        </div>

        {errore && <div style={stili.errore}>{errore}</div>}

        {loading ? (
          <div style={stili.vuoto}>Caricamento...</div>
        ) : bookmakers.length === 0 ? (
          <div style={stili.vuoto}>Nessun bookmaker registrato.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={stili.tabella}>
              <thead>
                <tr>
                  <th style={stili.th}>Nome</th>
                  <th style={stili.thCenter}>Stato</th>
                  <th style={stili.thNum}>Fee % default</th>
                  <th style={stili.thNum}>Saldo iniziale</th>
                  <th style={stili.thNum}>Saldo corrente</th>
                  <th style={stili.thCenter}>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {bookmakers.map(b => {
                  const colS = COLORI_STATO[b.stato] || { bg: "#F1F5F9", color: "#64748B" };
                  const saldo = saldoPerId(b.id);
                  return (
                    <tr key={b.id}>
                      <td style={stili.td}>
                        <strong>{b.nome}</strong>
                        {b.is_default && <span style={stili.badgeDefault}>PREDEFINITO</span>}
                      </td>
                      <td style={stili.tdCenter}>
                        <span style={{ ...stili.badgeStato, background: colS.bg, color: colS.color }}>
                          {b.stato}
                        </span>
                      </td>
                      <td style={stili.tdNum}>
                        {b.fee_pct_default !== null && b.fee_pct_default !== undefined
                          ? Number(b.fee_pct_default).toFixed(2) + " %"
                          : "—"}
                      </td>
                      <td style={stili.tdNum}>
                        {formatEur(b.saldo_iniziale_eur)}
                      </td>
                      <td style={stili.tdNum}>
                        {saldo ? (
                          <span
                            style={stili.saldoCellLink}
                            onClick={() => setBreakdownAperto(saldo)}
                            title="Clicca per vedere il dettaglio"
                          >
                            {formatEur(saldo.saldo_corrente)}
                          </span>
                        ) : (
                          formatEur(b.saldo_iniziale_eur)
                        )}
                      </td>
                      <td style={stili.tdCenter}>
                        <button
                          style={{ ...stili.btnIcona, color: "#2563EB" }}
                          onClick={() => { setBkInModifica(b); setModalBkAperto(true); }}
                          title="Modifica"
                        >
                          ✏️
                        </button>
                        <button
                          style={{ ...stili.btnIcona, color: "#C62828" }}
                          onClick={() => eliminaBk(b)}
                          title="Elimina"
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ═══ Card 2 — Movimenti ════════════════════════════════ */}
      <div style={stili.card}>
        <div style={stili.intestazioneCard}>
          <div>
            <h2 style={stili.titoloCard}>Movimenti</h2>
            <div style={stili.sottotitolo}>
              Storico depositi, prelievi e aggiustamenti.
            </div>
          </div>
          <button
            style={{ ...stili.btn, ...stili.btnPrimary }}
            onClick={() => { setMovInModifica(null); setModalMovAperto(true); }}
            disabled={bookmakers.length === 0}
          >
            + Nuovo movimento
          </button>
        </div>

        <div style={stili.filtroRiga}>
          <span style={stili.filtroLabel}>Filtra per bookmaker:</span>
          <select
            style={stili.selectInline}
            value={filtroBookmaker}
            onChange={e => setFiltroBookmaker(e.target.value)}
          >
            <option value="">Tutti</option>
            {bookmakers.map(b => (
              <option key={b.id} value={b.id}>{b.nome}</option>
            ))}
          </select>
        </div>

        {loading ? (
          <div style={stili.vuoto}>Caricamento...</div>
        ) : movimenti.length === 0 ? (
          <div style={stili.vuoto}>Nessun movimento registrato.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={stili.tabella}>
              <thead>
                <tr>
                  <th style={stili.th}>Data</th>
                  <th style={stili.th}>Bookmaker</th>
                  <th style={stili.thCenter}>Tipo</th>
                  <th style={stili.thNum}>Importo</th>
                  <th style={stili.th}>Note</th>
                  <th style={stili.thCenter}>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {movimenti.map(m => {
                  const colT = COLORI_TIPO[m.tipo] || { bg: "#F1F5F9", color: "#64748B" };
                  const segno = m.direzione === "-" ? -1 : 1;
                  const importoConSegno = Number(m.importo_eur || 0) * segno;
                  const colorImporto = importoConSegno > 0 ? "#166534" : importoConSegno < 0 ? "#991B1B" : "#334155";
                  return (
                    <tr key={m.id}>
                      <td style={stili.td}>{formatData(m.data)}</td>
                      <td style={stili.td}>{nomeBookmaker(m.bookmaker_id)}</td>
                      <td style={stili.tdCenter}>
                        <span style={{ ...stili.badgeTipo, background: colT.bg, color: colT.color }}>
                          {m.tipo}
                        </span>
                      </td>
                      <td style={{ ...stili.tdNum, color: colorImporto, fontWeight: 600 }}>
                        {formatEurConSegno(importoConSegno)}
                      </td>
                      <td style={{ ...stili.td, color: "#64748B", fontStyle: m.note ? "normal" : "italic" }}>
                        {m.note || "—"}
                      </td>
                      <td style={stili.tdCenter}>
                        <button
                          style={{ ...stili.btnIcona, color: "#2563EB" }}
                          onClick={() => { setMovInModifica(m); setModalMovAperto(true); }}
                          title="Modifica"
                        >
                          ✏️
                        </button>
                        <button
                          style={{ ...stili.btnIcona, color: "#C62828" }}
                          onClick={() => eliminaMovimento(m)}
                          title="Elimina"
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ═══ Modali ════════════════════════════════════════════ */}
      {modalBkAperto && (
        <ModalBookmaker
          bookmakerEsistente={bkInModifica}
          onChiudi={() => { setModalBkAperto(false); setBkInModifica(null); }}
          onSalva={onSalvaBk}
        />
      )}
      {modalMovAperto && (
        <ModalMovimento
          movimentoEsistente={movInModifica}
          bookmakers={bookmakers}
          bookmakerPreselezionato={filtroBookmaker || null}
          onChiudi={() => { setModalMovAperto(false); setMovInModifica(null); }}
          onSalva={onSalvaMov}
        />
      )}
      {breakdownAperto && (
        <PopupBreakdownSaldo
          saldoData={breakdownAperto}
          onChiudi={() => setBreakdownAperto(null)}
        />
      )}
    </div>
  );
}
